import { useEffect, useState } from 'react';

import FG1 from '../../images/FG1.png';
import BG2 from '../../images/BG2.png';
import BG3 from '../../images/BG3.png';
import BG4 from '../../images/BG4.png';
import BG5 from '../../images/BG5.png';

const Parallax = () => {
  const [xValue, setXValue] = useState(0);
  const [yValue, setYValue] = useState(0);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const newXValue = e.clientX - window.innerWidth / 2;
      const newYValue = e.clientY - window.innerHeight / 2;

      setXValue(newXValue);
      setYValue(newYValue);
    };

    window.addEventListener('mousemove', handleMouseMove);

    const parallax_el = document.querySelectorAll('.parallax');
    const updateParallax = () => {
      parallax_el.forEach((el) => {
        const spacex = el.dataset.spacex || 0.1;
        const spacey = el.dataset.spacey || 0.1;
        el.style.transform = `translateX(calc(-50% + ${
          -xValue * spacex
        }px)) translateY(calc(-50% + ${-yValue * spacey}px)) scale(1.2)`;
      });

      // Use requestAnimationFrame for smoother animation
      requestAnimationFrame(updateParallax);
    };

    requestAnimationFrame(updateParallax);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);

      // Stop the animation loop when the component unmounts
      cancelAnimationFrame(updateParallax);
    };
  }, [xValue, yValue]);

  return (
    <div id="hero">
      <div id="dimmer"></div>
      <img
        id="fg-1"
        className="parallax"
        data-spacex="0.06"
        data-spacey="0.09"
        src={FG1}
        alt="parallaxfg"
      />
      <img
        id="bg-2"
        className="parallax"
        data-spacex="0.1"
        data-spacey="0.13"
        src={BG2}
        alt="parallaxbg"
      />
      <img
        id="bg-3"
        className="parallax"
        data-spacex="0.13"
        data-spacey="0.15"
        src={BG3}
        alt="parallaxbg"
      />
      <img
        id="bg-4"
        className="parallax"
        data-spacex="0.18"
        data-spacey="0.2"
        src={BG4}
        alt="parallaxbg"
      />
      <img
        id="bg-5"
        className="parallax"
        data-spacex="0.15"
        data-spacey="0.2"
        src={BG5}
        alt="parallaxbg"
      />
    </div>
  );
};

export default Parallax;
